import React, { forwardRef } from 'react'
import { Item, ItemIcon, ItemTitle, ItemInfo, Separator, Icon, SuperLink } from '~ui';
import useItemInfo from './useItemInfo'

function SuggestionItem({ item, className='', forwardedRef, ...etc}) {
    const { icon, title, info, token } = useItemInfo(item)
    const { query } = item

    return (
        <>
            <Item 
                ref={forwardedRef}
                className={'ui-filter-item'+' '+className}
                data-token={token}
                data-id={item._id}
                {...etc}>
                {typeof icon == 'object' && icon}
                {typeof icon == 'string' && (
                    <ItemIcon className={'ui-filter-icon'}>
                        <Icon 
                            name={icon} />
                    </ItemIcon>
                )}

                <ItemTitle>
                    {title}
                </ItemTitle>

                <ItemInfo>
                    {info}
                </ItemInfo>

                {!etc.onClick ? (
                    <SuperLink 
                        to={`/my/0/${query}`}
                        tabIndex='0'/>
                ) : null}
            </Item>

            {item._id == 'current' && <Separator />}
        </>
    )
}

export default forwardRef((props, ref) => {
    return <SuggestionItem {...props} forwardedRef={ref} />
})